import React from 'react';
import { useTranslation } from 'react-i18next';

const LegalNotice = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 pt-24 pb-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md">
        {/* Header del documento */}
        <div className="border-b-4 border-cmv-green px-8 md:px-12 py-6">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
            {t('legal.avisoLegal.title')}
          </h1>
          <p className="text-sm text-gray-500 mt-2">CMV Maderas Tratadas S.L.</p>
        </div>

        {/* Contenido con estilo Word */}
        <div className="p-8 md:p-12">
          <div 
            className="legal-document prose prose-lg max-w-none"
            dangerouslySetInnerHTML={{ __html: t('legal.avisoLegal.content') }} 
          />
        </div>

        {/* Footer del documento */}
        <div className="border-t border-gray-200 px-8 md:px-12 py-6 bg-gray-50">
          <a 
            href="/"
            className="inline-flex items-center text-cmv-green hover:text-cmv-green/80 font-medium transition-colors"
          >
            ← {t('legal.backToHome')}
          </a>
        </div>
      </div>

      {/* Estilos CSS personalizados para formato Word */}
      <style jsx>{`
        .legal-document {
          font-family: 'Georgia', 'Times New Roman', serif;
          line-height: 1.8;
          color: #1f2937;
        }

        .legal-document h2 {
          font-size: 1.75rem;
          font-weight: 700;
          color: #111827;
          margin-top: 2rem;
          margin-bottom: 1rem;
          padding-bottom: 0.5rem;
          border-bottom: 2px solid #e5e7eb;
        }

        .legal-document h3 {
          font-size: 1.35rem;
          font-weight: 600;
          color: #374151;
          margin-top: 1.5rem;
          margin-bottom: 0.75rem;
        }

        .legal-document p {
          margin-bottom: 1rem;
          text-align: justify;
        }

        .legal-document strong {
          font-weight: 600;
          color: #111827;
        }

        .legal-document ul, .legal-document ol {
          margin-left: 2rem;
          margin-bottom: 1rem;
        }

        .legal-document li {
          margin-bottom: 0.5rem;
          padding-left: 0.5rem;
        }

        .legal-document blockquote {
          border-left: 4px solid #10b981;
          padding-left: 1rem;
          margin: 1.5rem 0;
          font-style: italic;
          color: #4b5563;
        }

        .legal-document table {
          width: 100%;
          border-collapse: collapse;
          margin: 1.5rem 0;
        }

        .legal-document th,
        .legal-document td {
          border: 1px solid #d1d5db;
          padding: 0.75rem;
          text-align: left;
        }

        .legal-document th {
          background-color: #f3f4f6;
          font-weight: 600;
        }
      `}</style>
    </div>
  );
};

export default LegalNotice;
